<script>
import LandingPageMixin from '@/mixins/landingpage'

export default {
  name: 'LandingPageDestinationAmerica',
  mixins: [ LandingPageMixin ],
  computed: {}
}
</script>

<style lang="scss" scoped>
@import './bootstrap.scss';
@import './main.scss';
</style>

<template>
  <h1>&nbsp;</h1>
</template>
